export default "__VITE_ASSET__Dktr4C2W__"